import { render } from "./AboutTeam.vue?vue&type=template&id=f714724c&scoped=true"
import script from "./AboutTeam.vue?vue&type=script&lang=js"
export * from "./AboutTeam.vue?vue&type=script&lang=js"

import "./AboutTeam.vue?vue&type=style&index=0&id=f714724c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f714724c"]])

export default __exports__